import { useState } from "react";
import { SendFormScreen } from "../../screen/SendFormScreen";
import { customToast } from "../../components/Toast";
import Send from "../../core/communication";

export const SendFormContainer = ({ modalIsOpen, handleCloseModal, selectedUsers }) => {
  const [usersAreConfirmed, setUsersAreConfirmed] = useState(false);
  const [sending, setSending] = useState(false);
  const [sendingCount, setSendingCount] = useState(0);
  const [template, setTemplate] = useState('');

  console.log(selectedUsers)

  const generateLinkAndSendMessages = async () => {
    if(!template) {
      customToast('Escreva um template de envio.', 'error');
      return;
    }

    try {
      setSending(true);
      let currentCount = 0;

      for (let i = 0; i < selectedUsers.length; i += 10) {
        const currentData = selectedUsers.slice(i, i+10);
        
        const response = await Send.post('/assistance-link/send-many-forms', {
          farmers: currentData,
          template,
        });
        setSendingCount(current => (current + response.links.length));
        currentCount += response.links.length;
      }

      customToast(`Links gerados e enviados para ${currentCount}/${selectedUsers.length}`, 'success');
    } catch(error) {
      console.log("Error -> ", error);
      customToast('Erro ao enviar links', 'error');
    }

    setSending(false);
  }

  return <SendFormScreen
    modalIsOpen={modalIsOpen}
    handleCloseModal={handleCloseModal}
    selectedUsers={selectedUsers}
    handleConfirmedUsers={() => setUsersAreConfirmed(!usersAreConfirmed)}
    usersAreConfirmed={usersAreConfirmed}
    sending={sending}
    sendingCount={sendingCount}
    generateLinkAndSendMessages={generateLinkAndSendMessages}
    template={template}
    handleChangeTemplate={(e) => setTemplate(e.target.value)}
  />
};